export default "__VITE_PUBLIC_ASSET__d1fc5037__"